<article *ngIf="presence">
  <app-muted-stackedbar [data]="presence"></app-muted-stackedbar>
</article>
